import { Column, Row, Text } from "@amzn/meridian";
import React from "react";
import { COLORS } from "src/constants/colors";
import { AI, MANUAL_OVERRIDE } from "src/constants/constants";
import { Result } from "src/data/types";

type ResultInstanceCardProps = {
  instanceNumber: number;
  evidenceUri: string;
  result: Result;
  showInstanceNumber: boolean;
  onClick?: () => void;
};

const ResultInstanceCard = ({
  instanceNumber,
  evidenceUri,
  result,
  showInstanceNumber,
  onClick,
}: ResultInstanceCardProps) => {
  const isPending = result.aiResult === "PENDING";
  const isCompliant = result.isCompliant ?? false;
  const isInspectorOverride = result.isInspectorOverride ?? false;
  
  const cardContent = (
    <Row
      widths={["fill", "fit"]}
      spacing="300"
      alignmentVertical="center"
      backgroundColor={COLORS.WHITE}
      spacingInset="300"
    >
      <Column spacing="100">
        {showInstanceNumber && (
          <Text type="b200">Instance #{instanceNumber}</Text>
        )}
        {isPending ? (
          <Row spacing="100" alignmentVertical="center">
            <div style={{ 
              width: "12px", 
              height: "12px", 
              border: "2px solid #f3f3f3",
              borderTop: "2px solid #FF9900",
              borderRadius: "50%",
              animation: "spin 1s linear infinite"
            }} />
            <Text color="secondary" type="b200">
              Analyzing...
            </Text>
          </Row>
        ) : (
          <Row spacing="200" alignmentVertical="center">
            <Text color={isCompliant ? "success" : "error"} type="b300">
              {isCompliant ? "Compliant" : "Non-Compliant"}
            </Text>
            <Row
              spacingInset="100 200"
              backgroundColor={
                isInspectorOverride
                  ? COLORS.AI_RESULT_OVERRIDE_COLOR
                  : COLORS.AI_RESULT_ACCEPTED_COLOR
              }
            >
              <Text
                type="b100"
                color={isInspectorOverride ? "primary" : "inverted"}
              >
                {isInspectorOverride ? MANUAL_OVERRIDE : AI}
              </Text>
            </Row>
          </Row>
        )}
      </Column>

      {!isPending && (
        <img
          src={evidenceUri}
          style={{
            height: "80px",
            width: "80px",
            objectFit: "cover",
            borderRadius: "4px",
          }}
          alt="Evidence"
        />
      )}
    </Row>
  );
  
  if (!isPending && onClick) {
    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={onClick}
      >
        {cardContent}
      </div>
    );
  }
  
  return cardContent;
};

export default ResultInstanceCard;
